export const MOBILE_MIN_WIDTH = 320;
export const MOBILE_MAX_WIDTH = 480;

export const TABLET_MIN_WIDTH = 481;
export const TABLET_MAX_WIDTH = 768;

export const LAPTOP_MIN_WIDTH = 769;
export const LAPTOP_MAX_WIDTH = 1024;

export const DESKTOP_MIN_WIDTH = 1025;
export const DESKTOP_MAX_WIDTH = 1200;

export const TV_MIN_WIDTH = 1201;
export const TV_MAX_WIDTH = 10000;
